import PlayerDetailContent from '@/features/guardian-player/components/player-detail';
import type { GuardianStackScreenProps } from '@/navigations/types';
import { useNavigation, useRoute } from '@react-navigation/native';
import React, { useCallback } from 'react';

type PlayerDetailRoute = GuardianStackScreenProps<'PlayerDetail'>['route'];
type PlayerDetailNavigation = GuardianStackScreenProps<'PlayerDetail'>['navigation'];

const PlayerDetailScreen = () => {
  const navigation = useNavigation<PlayerDetailNavigation>();
  const route = useRoute<PlayerDetailRoute>();
  const { player } = route.params;

  const handleOpenProgress = useCallback(() => {
    navigation.navigate('PlayerProgressTracker', { player });
  }, [navigation, player]);

  const handleOpenNotes = useCallback(() => {
    navigation.navigate('PlayerKitNotes', { player });
  }, [navigation, player]);

  const handleOpenGuardians = useCallback(() => {
    navigation.navigate('GuardianCircle', { player });
  }, [navigation, player]);

  const handleOpenComingSoon = useCallback(() => {
    navigation.navigate('ComingSoon');
  }, [navigation]);

  const handleBookClass = useCallback(() => {
    navigation.navigate('GuardianDashboard', { screen: 'Book' });
  }, [navigation]);

  const handleEdit = useCallback(() => {
    navigation.navigate('AddPlayer', { mode: 'edit', player });
  }, [navigation, player]);

  return (
    <PlayerDetailContent
      player={player}
      onBack={navigation.goBack}
      onOpenProgress={handleOpenProgress}
      onOpenNotes={handleOpenNotes}
      onOpenGuardians={handleOpenGuardians}
      onOpenComingSoon={handleOpenComingSoon}
      onBookClass={handleBookClass}
      onEdit={handleEdit}
    />
  );
};

export default PlayerDetailScreen;
